export const LOCATIONS = [
  {
    slug: "physiotherapist-in-bagnan",
    city: "Bagnan",
    title: "Best Physiotherapist in Bagnan — Mita Physio Cure",
    metaDesc:
      "Looking for the best physiotherapist in Bagnan? Mita Physio Cure by Sk Zishan Physio offers expert physiotherapy for back pain, stroke rehab, sports injury & more. ⭐ 4.5/5.",
    h1: "Best Physiotherapist in Bagnan",
    intro:
      "Mita Physio Cure is Bagnan's trusted physiotherapy clinic, led by Sk Zishan Physio (DPT). Whether you need stroke rehabilitation, back-pain treatment, sports-injury recovery or elderly care, we deliver evidence-based physiotherapy with one-on-one attention.",
    hoodPara:
      "We serve every neighbourhood in Bagnan — Birampur, Bagnan Station Road, Kulgachhia, Baruipara, Ghoraghata and more. Home visits available across all Bagnan localities.",
  },
  {
    slug: "home-physiotherapy-bagnan",
    city: "Bagnan (Home Visit)",
    title: "Home Physiotherapy in Bagnan — Doorstep Physio Visit",
    metaDesc:
      "Home physiotherapy in Bagnan by Mita Physio Cure. Doorstep sessions for stroke, post-surgery, elderly & back pain. Call +91 74777 07139.",
    h1: "Home Physiotherapy in Bagnan",
    intro:
      "Skip the travel — our certified physiotherapist visits your home in Bagnan with all required equipment. Perfect for elderly patients, stroke survivors, post-operative recovery and anyone who can't easily travel to a clinic.",
    hoodPara:
      "Home physiotherapy visits available across Bagnan, Birampur, Kulgachhia, Deulti and surrounding areas — 7 days a week.",
  },
  {
    slug: "physiotherapist-in-howrah",
    city: "Howrah",
    title: "Physiotherapist in Howrah — Trusted Clinic & Home Visits",
    metaDesc:
      "Physiotherapist in Howrah offering clinic and home visits. Expert care by Sk Zishan Physio at Mita Physio Cure. Book: +91 74777 07139.",
    h1: "Trusted Physiotherapist Serving Howrah District",
    intro:
      "From Bagnan we serve patients across the wider Howrah district. Whether you visit our Birampur clinic or need a home physiotherapist, we bring the same clinical standards and personal care.",
    hoodPara:
      "Home visits available across Howrah — Bagnan, Amta, Uluberia, Panchla, Domjur and neighbouring areas.",
  },
  {
    slug: "physiotherapist-in-amta",
    city: "Amta",
    title: "Physiotherapist in Amta — Home Visit Physiotherapy",
    metaDesc:
      "Physiotherapy in Amta by Mita Physio Cure. Home visits for stroke, back pain, sciatica, sports injury. Call +91 74777 07139.",
    h1: "Physiotherapist in Amta",
    intro:
      "Serving Amta and surrounding areas with home physiotherapy visits. Our physiotherapist travels to your doorstep for personalised, one-on-one treatment.",
    hoodPara:
      "Home visits typically scheduled 3–4 times a week in Amta — call to confirm availability for your specific date.",
  },
  {
    slug: "physiotherapist-in-uluberia",
    city: "Uluberia",
    title: "Physiotherapist in Uluberia — Sports & Home Physio",
    metaDesc:
      "Physiotherapist in Uluberia. Sports injury, back pain, stroke rehab and home physiotherapy by Mita Physio Cure. Book: +91 74777 07139.",
    h1: "Physiotherapist in Uluberia",
    intro:
      "Mita Physio Cure serves Uluberia patients with home visits and clinic appointments. Popular among athletes for sports-injury rehabilitation and post-surgery recovery.",
    hoodPara:
      "Uluberia home visits scheduled weekly — plan your sessions in advance for the best slots.",
  },
];
